import React from "react";
import {t} from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";
export default function cashouttype () {
    return (
        <React.Fragment>
            <div className="ticket-results-view-p">
            <CountDownComponent second={30}/>
            <div className="mini-logo-container"></div>
            <p className='cashout-p'>{t("Select cash out type")}</p>
                <div className='cashouttype-popup'>
                    <button className="button-view" onClick={this.props.openPopup("cashout")}>{t("Cashout")}</button>
                    <button className="button-view" onClick={this.props.openPopup("cashoutByTicket")}>{t("Ticket")}</button>
                </div>
            </div>
        </React.Fragment>
    );
}